import { useRouter } from 'next/router';
import {
    removePageSpecificParams,
    removeParameter
} from '@zoopla/listing-search/url';

export const useGetMapViewUrl = (editMode = false) => {
    const { asPath } = useRouter();

    const href = `/${asPath.split('/')[1]}${asPath.replace(
        /(for-sale|to-rent|new-homes)/,
        'map'
    )}`;
    const mapViewPath = removePageSpecificParams(href);

    if (editMode) {
        const mapViewPathNoMode = removeParameter(mapViewPath, 'mapMode');
        if (mapViewPathNoMode.includes('?'))
            return `${mapViewPathNoMode}&mapMode=draw`;
        else return `${mapViewPathNoMode}?mapMode=draw`;
    }

    return mapViewPath;
};
